import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Gift } from 'lucide-react';
export function BonusSection() {
  return <section className="py-16 px-4 bg-slate-950" data-id="element-15">
      <div className="max-w-2xl mx-auto" data-id="element-16">
        <FadeIn className="text-center mb-12" data-id="element-17">
          <Gift className="w-10 h-10 text-amber-500 mx-auto mb-6" strokeWidth={2} data-id="element-18" />
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-white tracking-wide" data-id="element-19">
            LOS 2 BONOS INCLUIDOS
          </h2>
        </FadeIn>

        <div className="space-y-8" data-id="element-20">
          {/* Bono 1 */}
          <FadeIn delay={0.1} data-id="element-21">
            <div className="bg-slate-900 border border-slate-800 border-t-4 border-t-green-500 rounded-b-xl p-6 md:p-8 shadow-md" data-id="element-22">
              <p className="text-white font-bold text-lg mb-2 flex items-center gap-2" data-id="element-23">
                <span data-id="element-24">🟢</span> BONO 1
              </p>
              <h3 className="text-xl md:text-2xl font-bold text-green-500 mb-4" data-id="element-25">
                Diagnóstico Express de Dolor y Ajuste Fino
              </h3>
              <p className="text-slate-400 text-base md:text-lg leading-relaxed" data-id="element-26">
                El mapa completo de dolor del ciclista. Tabla Síntoma → Causa →
                Ajuste. Los 5 tests caseros y el protocolo de ajuste fino en 15
                minutos. Sin biomecánico. Sin gastar un peso extra.
              </p>
            </div>
          </FadeIn>

          {/* Bono 2 */}
          <FadeIn delay={0.2} data-id="element-27">
            <div className="bg-slate-900 border border-slate-800 border-t-4 border-t-blue-500 rounded-b-xl p-6 md:p-8 shadow-md" data-id="element-28">
              <p className="text-white font-bold text-lg mb-2 flex items-center gap-2" data-id="element-29">
                <span data-id="element-30">🔵</span> BONO 2
              </p>
              <h3 className="text-xl md:text-2xl font-bold text-blue-500 mb-4" data-id="element-31">
                Guía de Estrategia de Subidas
              </h3>
              <p className="text-slate-400 text-base md:text-lg leading-relaxed" data-id="element-32">
                La Fórmula 30/40/30. Cadencia objetivo por tipo de subida. Guion
                de cambios paso a paso. Las 3 fichas imprimibles para subida
                corta, media y larga. Para aplicar en tu próxima salida.
              </p>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}